var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10557 1.55279C5.27496 1.214 5.62123 1 6 1H18C18.3788 1 18.725 1.214 18.8944 1.55279L19.618 3H21C21.5523 3 22 3.44772 22 4V7C22 7.55228 21.5523 8 21 8H19.9356L18.9978 22.0665C18.9628 22.5918 18.5265 23 18 23H6C5.47354 23 5.03723 22.5918 5.00221 22.0665L4.06445 8H3C2.44772 8 2 7.55228 2 7V4C2 3.44772 2.44772 3 3 3H4.38197L5.10557 1.55279ZM4 6V5H5C5.37877 5 5.72504 4.786 5.89443 4.44721L6.61803 3H17.382L18.1056 4.44721C18.275 4.786 18.6212 5 19 5H20V6H4ZM6.06889 8L6.93555 21H17.0644L17.9311 8H6.06889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacks);
export default __webpack_public_path__ + "static/media/snacks.33dced1d24dca7b06e51d4a97edd2053.svg";
export { ForwardRef as ReactComponent };